/** Canonical, runtime-safe locale contract shared by browser and server code. */
export const PRIVANA_FALLBACK_LOCALE = 'en-GB'

export const PRIVANA_LOCALES = Object.freeze({
  'en-GB': Object.freeze({ code: 'en-GB', name: 'English (United Kingdom)', nativeName: 'English (United Kingdom)', enabled: true, fallback: null }),
  es: Object.freeze({ code: 'es', name: 'Spanish', nativeName: 'Español', enabled: true, fallback: PRIVANA_FALLBACK_LOCALE }),
  'fr-FR': Object.freeze({ code: 'fr-FR', name: 'French', nativeName: 'Français', enabled: true, fallback: PRIVANA_FALLBACK_LOCALE }),
  'it-IT': Object.freeze({ code: 'it-IT', name: 'Italian', nativeName: 'Italiano', enabled: true, fallback: PRIVANA_FALLBACK_LOCALE }),
})

export const SUPPORTED_LOCALE_CODES = Object.freeze(Object.keys(PRIVANA_LOCALES))

export function isSupportedLocale(value) {
  return typeof value === 'string' && PRIVANA_LOCALES[value]?.enabled === true
}

/** Return a canonical supported locale, or null when the input is not compatible. */
export function canonicalizeSupportedLocale(value) {
  if (typeof value !== 'string') return null
  const candidate = value.trim().replaceAll('_', '-')
  if (!candidate || !/^[a-zA-Z]{2,3}(?:-[a-zA-Z]{2,4})?$/.test(candidate)) return null
  const language = candidate.split('-')[0].toLowerCase()
  if (language === 'en') return PRIVANA_FALLBACK_LOCALE
  if (language === 'es') return 'es'
  if (language === 'fr') return 'fr-FR'
  if (language === 'it') return 'it-IT'
  return null
}

export function normalizeLocale(value) {
  return canonicalizeSupportedLocale(value) ?? PRIVANA_FALLBACK_LOCALE
}

/** Phase 2 supplies persisted values to these already-defined precedence slots. */
export function resolveEffectiveLocale({ individualLocale, clubLocale, runtimeLocale } = {}) {
  for (const candidate of [individualLocale, clubLocale, runtimeLocale]) {
    const canonicalLocale = canonicalizeSupportedLocale(candidate)
    if (canonicalLocale) return canonicalLocale
  }
  return PRIVANA_FALLBACK_LOCALE
}
